var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("WebPlayerStream", {
    ref: "webPlayerStream",
    attrs: { "on-submit-password": _vm.onSubmitPassword, stream: _vm.stream },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }